import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Spinner, Box } from '@chakra-ui/react';
import { useAuth } from '../../contexts/AuthContext';
import { isWorkspacePreviewUser } from '../../pages/CRM/Workspace/workspaceAccess';

/**
 * Route guard for the Person Workspace preview pages.
 *
 * Grants access to the allowlisted preview user(s) and admins (SuperAdmin /
 * CRM Admin) per workspaceAccess.js; every other authenticated user is
 * redirected to the CRM dashboard. Follows the SuperAdminRoute/NewFeatureRoute
 * pattern: the page component must be rendered inside `render` — passing
 * `component` through to <Route> alongside `render` would make React Router
 * ignore `render` entirely (component takes precedence) and bypass the guard.
 */
const WorkspacePreviewRoute = ({ component: Component, children, ...rest }) => {
  const { currentUser, loading, SuperAdmin } = useAuth();

  if (loading) {
    return (
      <Box w="100%" h="100vh" display="flex" justifyContent="center" alignItems="center">
        <Spinner size="xl" />
      </Box>
    );
  }

  const allowed = !!currentUser && isWorkspacePreviewUser(currentUser, SuperAdmin);

  return (
    <Route
      {...rest}
      render={(routeProps) =>
        allowed ? (
          Component ? <Component {...routeProps} /> : children
        ) : (
          <Redirect
            to={{
              pathname: '/crm/dashboard',
              state: { from: routeProps.location },
            }}
          />
        )
      }
    />
  );
};

export default WorkspacePreviewRoute;
